import {NbMenuItem} from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
    // {
    //   title: 'Overzicht',
    //   icon: 'nb-home',
    //   link: '/admin/locations',
    //   home: true,
    // },
    // {
    //   title: 'FEATURES',
    //   group: true,
    // },
    {
        title: 'Locaties',
        icon: 'ion-android-pin',
        link: '/admin/locations',
    },
    {
        title: 'Reizen',
        icon: 'ion-person-stalker',
        link: '/admin/groups',
    },
    {
        title: 'Kamp update',
        icon: 'ion-ios-book-outline',
        link: '/admin/diary',
    },
    {
        title: 'Contact berichten',
        icon: 'ion-email',
        link: '/admin/messages',
    },
    {
        title: 'Kinderen',
        icon: 'ion-ios-people',
        link: '/admin/children',
    },
    {
        title: 'Nieuwsberichten',
        icon: 'ion-speakerphone',
        link: '/admin/broadcasts',
        // children: [
        //   {
        //     title: 'TinyMCE',
        //     link: '/pages/editors/tinymce',
        //   },
        //   {
        //     title: 'CKEditor',
        //     link: '/pages/editors/ckeditor',
        //   },
        // ],
    },
];
